import React, { useEffect, useRef, useState } from 'react'
import { Breadcrumb } from '../../../../components/ui/breadcrumb'
import { useNavigate } from 'react-router-dom'
import { Label } from '../../../../components/ui/label'
import { Combobox } from '../../../../components/ui/combobox'
import toast, { Toaster } from 'react-hot-toast'
import axios from '../../../../lib/axios'
import useAuth from '../../../../hooks/useAuth'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux'
import { RadioGroup, RadioGroupItem } from '../../../../components/ui/radio-group'
import { DatePicker } from '../../../../components/ui/datepicker'
import { addDays, format, isBefore, isSameMonth, isToday, subMonths, subWeeks } from 'date-fns'
import { Button } from '../../../../components/ui/button'
import { Input } from '../../../../components/ui/input'
import { Tablist, TablistItem } from '../../../../components/ui/tablist'
import Coins from './input/Coins'
import Notes from './input/Notes'
import { isInterface } from '../../../../lib/utils'
import PlannedStopsCalendar from '../../../../components/portal/stop/PlannedStopsCalendar'
import { DayObject } from '../../../../components/portal/stop/calendar/Calendar'
import { convertToDate, formatDateToYYYYMMDD } from '../../../../lib/date'
import { CoinsIcon, Eye, EyeOff, HelpCircle, Info } from 'lucide-react'
import Concept from './concept/Concept'
import { useQuery } from '@tanstack/react-query'
import PreviousOrders from './orders/PreviousOrders'
import { getCustomerList } from '../../../../lib/fetch/customer'
import { useTranslation } from 'react-i18next'
import ReactGA from "react-ga4";
import { createTicket } from '../../../../lib/ticket/create-ticket'
import { CONFIG } from '../../../../config'
import { Tab, TabItem } from '../../../../components/ui/tab'
import OrderForeignCurrencyForm from './foreign-currency/OrderForeignCurrencyForm'
import { fetchOrderQuota, pickCascade, OrderQuota } from '../../../../lib/fetch/orderQuota'

type Subpage = 'c' | 'n' | ''

const Main = () => {
    const { auth } = useAuth()
    const { t } = useTranslation()
    const navigate = useNavigate()

    const partners = useSelector((state:RootState)=>state.partners);
    const customers = useSelector((state:RootState)=>state.customers);
    const coupure = useSelector((state:RootState)=>state.coupure)

    const [selected_subpage, setselected_subpage] = useState<Subpage>('');
    const [denom, setdenom] = useState<Denom | StateType>('loading');
    const [view_form, setview_form] = useState<boolean>(true);

    const isEdit = useRef(false);
    const isEditDraft = useRef<null | number>(null)

    const [type_order, settype_order] = useState<'eur' | 'foreign'>(() =>
      CONFIG.order_and_collect.order.enable_foreign_currency
        ? ((window.sessionStorage.getItem('bestelling-plaatsen-tab') as 'eur' | 'foreign') || 'eur')
        : 'eur'
    );
    useEffect(() => { window.sessionStorage.setItem('bestelling-plaatsen-tab', type_order) }, [type_order]);

    const [selected_date, setselected_date] = useState<Date | undefined>();
    const [selected_event, setselected_event] = useState<DayObject | null>(null);
    const [selected_partner, setselected_partner] = useState<string | null>(null);
    const [selected_customer, setselected_customer] = useState<string | null>(null);

    const [customers_list, setcustomers_list] = useState<Customer[] | null>();
    const [partner_kassas, setpartner_kassas] = useState<Kassa[] | null>(null);
    const [reference, setreference] = useState<string>('');
    const [coupures, setcoupures] = useState<CoupureInput[] | null>(null);
    const [denom_settings, setdenom_settings] = useState<{
      orderperwafel: boolean
      ordercoins: boolean
      ordernotes: boolean
      announcecoins: boolean
      announcenotes: boolean
    }>({
      orderperwafel: false,
      ordercoins: true,
      ordernotes: true,
      announcecoins: false,
      announcenotes: false,
    });
    const [no_quota_warning, setno_quota_warning] = useState<boolean>(false);
    const [quota_levels, setquota_levels] = useState<OrderQuota | null>(null);
    const [applied_level, setapplied_level] = useState<'customer' | 'partner' | 'kassa' | null>(null);

    const { data:kassas } = useQuery<Kassa[] | null>({
      queryKey: ['user-kassa'],
      queryFn: async () => {
        try {
          if(!CONFIG.order_and_collect.order.enable_foreign_currency){ return null }
          const {data} = await axios.get(`kassa/get`, { params: {
            token: auth.data?.token,
            relnr: auth.data?.partner
          }})
          if(data.errorcode !== 0) { throw new Error(data.errorcode) }
          if(!Array.isArray(data.object)) { console.log('geen kassa ingesteld'); throw new Error() }

          return data.object
        } catch (err) {
          console.log(err)
          return null
        }
      }
    })
    
    const {refetch:refetch_concept} = useQuery<null | OrderDraft[]>({
      queryKey: ['order_concept'],
      queryFn: async () => {
          try {
              const relnr = (selected_customer && selected_customer !== 'clear') ? selected_customer : ''
              const {data} = await axios.post(`order/draft/search`, {
                  token: auth.data?.token,
                  partner: selected_partner || '',
                  relnr,
                  status: '001'
              })
              if(data.errorcode === 0 && Array.isArray(data.object.orderdraft)) { return data.object.orderdraft }
              else { return null; }
          } catch (error) {
              console.log(error)
              return null;
          }
      }
    })

    const {refetch:refetch_orders} = useQuery<OrderDraft[] | null>({
      queryKey: ['previous_orders'],
      queryFn: async () => {
          try {
              const relnr = (selected_customer && selected_customer !== 'clear') ? selected_customer : ''
              const {data} = await axios.post(`order/draft/search`, {
                  token: auth.data?.token,
                  startdate: formatDateToYYYYMMDD(subMonths(new Date(), 1)),
                  enddate: formatDateToYYYYMMDD(new Date()),
                  partner: selected_partner || '',
                  relnr,
                  status: '009',
                  searchby: 'C'
              })
              if(data.errorcode === 0 && Array.isArray(data.object.orderdraft)) { return data.object.orderdraft }
              else { return null; }
          } catch (error) {
              console.log(error)
              return null
          }
      }
    })

    useEffect(()=>{
      if (auth.data?.partner && auth.data?.partner.split(",").length === 1) {
        handlePickPartner(auth.data.partner.split(",")[0])
      }
    }, [])


    const handlePickPartner = async (relnr:string) => {
      if (!relnr) return
      console.log('[PlaceOrder] handlePickPartner', { relnr, prev_partner: selected_partner })
      try {
        if(selected_partner!==relnr){
          console.log('[PlaceOrder] partner changed → reset customer/kassa/coupures/subpage/date/event')
          setselected_customer('clear')
          setpartner_kassas(null)
          setcoupures(null)
          setselected_subpage('')
          setselected_date(undefined)
          setselected_event(null)
          setno_quota_warning(false)
        }
        setselected_partner(relnr);
        setcustomers_list(null);

        const list = await getCustomerList(auth, relnr)
        console.log('[PlaceOrder] getCustomerList →', { count: list?.length, list })
        if(list){ setcustomers_list(list) }
        if(list.length === 1){
          console.log('[PlaceOrder] auto-selecting single customer', list[0].relnr)
          setselected_customer(list[0].relnr.toString())
        }
      } catch (error) {
        console.error('[PlaceOrder] handlePickPartner ERROR', error)
        toast.error(t("order_and_pickup.o_place_order.toast_wrong"))
      }
    }

    useEffect(() => {
      if (!selected_partner) {
        console.log('[PlaceOrder] kassa-fetch skipped: no partner')
        setpartner_kassas(null);
        return;
      }
      let cancelled = false
      ;(async () => {
        try {
          console.log('[PlaceOrder] GET kassa/get', { partner: selected_partner })
          const { data } = await axios.get('kassa/get', {
            params: { token: auth.data?.token }
          })
          if (cancelled) { console.log('[PlaceOrder] kassa/get response ignored (cancelled)'); return }
          console.log('[PlaceOrder] kassa/get response', data)
          if (data.errorcode !== 0) throw new Error(data.message)
          const all: Kassa[] = Array.isArray(data.object) ? data.object : []
          const partnerRelnr = parseFloat(selected_partner)
          const filtered = all.filter(k => k.relnr === partnerRelnr)
          console.log('[PlaceOrder] kassa filtered for partner', { partnerRelnr, total: all.length, filtered: filtered.length, list: filtered })
          setpartner_kassas(filtered)
        } catch (err) {
          console.error('[PlaceOrder] kassa/get ERROR', err)
          if (!cancelled) setpartner_kassas([])
        }
      })()
      return () => { cancelled = true }
    }, [selected_partner])

    useEffect(() => {
      // Ook bij partnerwissel refetchen (customer is dan even 'clear' → relnr='' = partner-breed),
      // anders blijven de concepten/bestellingen van de vorige partner staan.
      if (selected_partner) {
        console.log('[PlaceOrder] refetch concept+orders', { partner: selected_partner, customer: selected_customer })
        refetch_concept()
        refetch_orders()
      }
    }, [selected_customer, selected_partner])

    // Stap 1 — alle niveaus ophalen (eindklant, partner, kassa's) en de settings bepalen.
    // De effectieve quota per type wordt in stap 2 gekozen via de cascade.
    useEffect(() => {
      const customer_relnr = (selected_customer && selected_customer !== 'clear') ? selected_customer : null
      if (!customer_relnr || !selected_partner) {
        console.log('[PlaceOrder] quota skipped: no partner/customer')
        setquota_levels(null)
        setdenom('loading')
        setno_quota_warning(false)
        return
      }
      setdenom('loading')
      setno_quota_warning(false)
      let cancelled = false
      ;(async () => {
        try {
          const quota = await fetchOrderQuota(auth, {
            customerid: parseFloat(customer_relnr),
            partner: selected_partner,
            kassas: partner_kassas || [],
          })
          if (cancelled) return
          console.log('[PlaceOrder] quota levels', quota)
          setquota_levels(quota)
          // OR over alle niveaus: een type is orderbaar zodra eender welk niveau het toelaat.
          const lvls = [quota.customer, quota.partner, ...quota.kassas.map(k => k.level)]
          const orFlag = (k: 'orderperwafel'|'ordercoins'|'ordernotes'|'announcecoins'|'announcenotes') => lvls.some(l => !!l?.[k])
          const settings = {
            orderperwafel: orFlag('orderperwafel'),
            ordercoins: orFlag('ordercoins'),
            ordernotes: orFlag('ordernotes'),
            announcecoins: orFlag('announcecoins'),
            announcenotes: orFlag('announcenotes'),
          }
          setdenom_settings(settings)
          // denom als leeg Denom-object zodat het een geldig object is; stap 2 vult het type.
          setdenom({ partnerid: 0, ...settings, coins: [], notes: [] })
        } catch (error) {
          console.error('[PlaceOrder] quota fetch ERROR', error)
          if (!cancelled) { setquota_levels(null); setdenom('error'); setno_quota_warning(false) }
        }
      })()
      return () => { cancelled = true }
    }, [selected_partner, selected_customer, partner_kassas])

    // Stap 2 — cascade voor het gekozen type: eindklant > partner > kassa, eerste niet-lege wint.
    useEffect(() => {
      if (!quota_levels) { setapplied_level(null); return }
      if (selected_subpage !== 'c' && selected_subpage !== 'n') { setapplied_level(null); return }
      const lvls = [quota_levels.customer, quota_levels.partner, ...quota_levels.kassas.map(k => k.level)]
      const orFlag = (k: 'ordercoins'|'ordernotes'|'announcecoins'|'announcenotes') => lvls.some(l => !!l?.[k])
      const base = {
        partnerid: 0,
        ordercoins: orFlag('ordercoins'),
        ordernotes: orFlag('ordernotes'),
        announcecoins: orFlag('announcecoins'),
        announcenotes: orFlag('announcenotes'),
      }
      const picked = pickCascade(quota_levels, selected_subpage)
      console.log('[PlaceOrder] cascade pick', { type: selected_subpage, level: picked.level, found: picked.found, rows: picked.rows.length })
      setno_quota_warning(!picked.found)
      setapplied_level(picked.found ? picked.level : null)
      setdenom({
        ...base,
        coins: selected_subpage === 'c' ? picked.rows : [],
        notes: selected_subpage === 'n' ? picked.rows : [],
      })
    }, [quota_levels, selected_subpage])

    const onChangeInput = (coupure:CoupureType, qty:number) => {
      qty = Math.max(0, Math.round(qty))
      if(coupures) {

          let tmp = [...coupures]
          const existingIndex = coupures.findIndex(item => item.coupure === coupure);

          if(existingIndex !== -1){
            tmp[existingIndex] = {qty:qty, coupure:coupure}
            if(qty === 0){ tmp.splice(existingIndex, 1) }
          }
          else {
            tmp.push({qty:qty, coupure:coupure}) 
          }
          

          setcoupures(tmp);
      }
      else {
          setcoupures([{coupure:coupure, qty:qty}])
      }
    };

    // Een type is beschikbaar als de cascade er effectief quota voor vindt (niet enkel de orderbaar-vlag).
    const quotaAvail = {
      c: quota_levels ? pickCascade(quota_levels, 'c').found : false,
      n: quota_levels ? pickCascade(quota_levels, 'n').found : false,
    }

    // Bepaalt het zichtbare type. Een gekozen kassa (type 'c'/'n') heeft voorrang
    // op de leverdag-cn; zonder kassa ('') stuurt de leverdag-cn de keuze.
    const resolveSubpage = (eventCn: string | undefined, type: Subpage): Subpage => {
      if (type === 'c') return quotaAvail.c ? 'c' : ''
      if (type === 'n') return quotaAvail.n ? 'n' : ''
      if (eventCn === 'C') return quotaAvail.c ? 'c' : ''
      if (eventCn === 'N') return quotaAvail.n ? 'n' : ''
      return quotaAvail.c ? 'c' : (quotaAvail.n ? 'n' : '')
    }

    const onPickDate = (v:DayObject) => {
      console.log('[PlaceOrder] onPickDate', { date: v.date, cn: v.cn, denom_settings })
      setselected_subpage(resolveSubpage(v.cn, ''))
      setselected_event(v)
    }

    // Concept valideren/bewerken zet partner+klant+leverdag synchroon, vóór de quota-fetch.
    // Daardoor resolvet onPickDate het type tegen lege quota → ''. Zodra de quota geladen is,
    // het type her-resolven uit de leverdag-cn (blijft '' als er echt geen quota voor dat type is).
    useEffect(() => {
      if (!quota_levels || !selected_event) return
      if (selected_subpage === 'c' || selected_subpage === 'n') return
      const resolved = resolveSubpage(selected_event.cn, '')
      console.log('[PlaceOrder] subpage re-resolve', { event_cn: selected_event.cn, quotaAvail, resolved })
      if (resolved) setselected_subpage(resolved)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quota_levels, selected_event])

    function isCoupuresValid() {
      let valid = false;
      if(coupures){
        let tmp = [...coupures]
        if(selected_subpage === 'c'){
          valid = tmp.filter(i=>parseFloat(i.coupure) <= 2 && i.qty > 0).length > 0
        }
        if(selected_subpage === 'n'){
          valid = tmp.filter(i=>parseFloat(i.coupure) > 2 && i.qty > 0).length > 0
        }
      }
      return valid;
    }

    // Rows with minqty >= 1 must be filled with at least minqty pieces.
    // Rows with minqty === 0 may stay empty.
    function getUnmetMinRows(): { coupure: number, minqty: number, perqty: number, currentPieces: number }[] {
      if(!isInterface(denom, {} as Denom)) return []
      const rows: Coin[] = selected_subpage === 'c' ? (denom.coins ?? [])
                       : selected_subpage === 'n' ? (denom.notes ?? [])
                       : []
      const unmet: { coupure: number, minqty: number, perqty: number, currentPieces: number }[] = []
      for(const row of rows){
        if(row.minqty < 1) continue
        const entry = coupures?.find(c => parseFloat(c.coupure as string) === row.coupure)
        const currentMonetary = entry?.qty ?? 0
        const currentPieces = row.perqty > 0 ? currentMonetary / row.perqty : 0
        if(currentPieces < row.minqty){
          unmet.push({ coupure: row.coupure, minqty: row.minqty, perqty: row.perqty, currentPieces })
        }
      }
      return unmet
    }

  // Na opslaan: terug naar de staat van een verse klantselectie. Partner+klant behouden,
  // maar leverdag/type/coupures/referentie wissen zodat de leverdag opnieuw door de
  // kalender-/quota-validatie moet (PlannedStopsCalendar laat enkel geldige dagen toe).
  const resetOrderSelection = () => {
    setcoupures(null)
    setselected_subpage('')
    setselected_date(undefined)
    setselected_event(null)
    setreference('')
    setno_quota_warning(false)
  }

  const saveDraft = async () => {
    console.log('[PlaceOrder] saveDraft start', { selected_partner, selected_customer, selected_subpage, selected_event, coupures, denom_settings, isEdit: isEdit.current, isEditDraft: isEditDraft.current })
    try {
      if(!selected_customer) { console.warn('[PlaceOrder] saveDraft blocked: no customer'); toast.error(t("order_and_pickup.o_place_order.toast_select_customer")); return; }
      if(selected_subpage === '') { console.warn('[PlaceOrder] saveDraft blocked: no type'); toast.error(t("order_and_pickup.o_place_order.toast_select_type")); return; }
      if(!selected_event?.date) { console.warn('[PlaceOrder] saveDraft blocked: no date'); toast.error(t("order_and_pickup.o_place_order.toast_select_date")); return; }
      if(!coupures) { console.warn('[PlaceOrder] saveDraft blocked: no coupures'); toast.error(t("order_and_pickup.o_place_order.toast_select_order")); return; }
      const unmet = getUnmetMinRows()
      if(unmet.length > 0){
        console.warn('[PlaceOrder] saveDraft blocked: minqty unmet', unmet)
        const list = unmet.map(u => `€${u.coupure} (min ${u.minqty})`).join(', ')
        toast.error(t("order_and_pickup.o_place_order.toast_min_qty", { list, defaultValue: `Minimum niet bereikt voor: ${list}` }))
        return
      }

      type Body = {
        token: string | undefined;
        relnr: string;
        cn: "c" | "n";
        date: string;
        reference: string;
        coupures: CoupureInput[];
        kassa: string | null;
        orderperwafel: boolean;
        ordercoins: boolean;
        ordernotes: boolean;
        announcecoins: boolean;
        announcenotes: boolean;
        id?: number;
      }

      const obj:Body = {
        token: auth.data?.token,
        relnr: selected_customer,
        cn: selected_subpage,
        date: formatDateToYYYYMMDD(selected_event.date || new Date),
        reference: reference,
        coupures: coupures,
        kassa: quota_levels?.kassas.find(k => (k.cn || '').toLowerCase().includes(selected_subpage))?.kassaid?.toString() ?? null,
        orderperwafel: denom_settings.orderperwafel,
        ordercoins: denom_settings.ordercoins,
        ordernotes: denom_settings.ordernotes,
        announcecoins: denom_settings.announcecoins,
        announcenotes: denom_settings.announcenotes,
      }

      toast.loading(t("order_and_pickup.o_place_order.toast_loading_order"), {id:'saveDraft'})

      let URL = 'order/draft/create'
      if(isEdit.current && isEditDraft.current){
        URL = 'order/draft/update'
        obj.id = isEditDraft.current
      }

      console.log('[PlaceOrder] POST', URL, obj)
      const {data} = await axios.post(`${URL}`, obj)
      console.log('[PlaceOrder]', URL, 'response', data)
      if(data.errorcode !== 0) { throw new Error(data.errorcode) }
      isEdit.current = false;
      isEditDraft.current = null;

      toast.success(t("order_and_pickup.o_place_order.toast_success_order"), {id:'saveDraft'})
      resetOrderSelection();
      refetch_concept();
      refetch_orders()
      
      ReactGA.event({
        category: 'Order draft',
        action: 'order_draft_success',
      })
    } catch (error) {
      console.error('[PlaceOrder] saveDraft ERROR', error);
      toast.error(t("order_and_pickup.o_place_order.toast_error_order"), {id:'saveDraft'})

      ReactGA.event({
        category: 'Order draft',
        action: 'order_draft_failed',
      })
    }
  }

  const saveOrder = async () => {
    console.log('[PlaceOrder] saveOrder start', { selected_partner, selected_customer, selected_subpage, selected_event, coupures, denom_settings })
    isEdit.current = false;
    try {
      if(!selected_customer) { console.warn('[PlaceOrder] saveOrder blocked: no customer'); toast.error(t("order_and_pickup.o_place_order.toast_select_customer")); return; }
      if(selected_subpage === '') { console.warn('[PlaceOrder] saveOrder blocked: no type'); toast.error(t("order_and_pickup.o_place_order.toast_select_type")); return; }
      if(!selected_event?.date) { console.warn('[PlaceOrder] saveOrder blocked: no date'); toast.error(t("order_and_pickup.o_place_order.toast_select_date")); return; }
      if(!coupures) { console.warn('[PlaceOrder] saveOrder blocked: no coupures'); toast.error(t("order_and_pickup.o_place_order.toast_select_order")); return; }
      const unmet = getUnmetMinRows()
      if(unmet.length > 0){
        console.warn('[PlaceOrder] saveOrder blocked: minqty unmet', unmet)
        const list = unmet.map(u => `€${u.coupure} (min ${u.minqty})`).join(', ')
        toast.error(t("order_and_pickup.o_place_order.toast_min_qty", { list, defaultValue: `Minimum niet bereikt voor: ${list}` }))
        return
      }

      if(isBefore(selected_event.date, new Date)){ console.warn('[PlaceOrder] saveOrder blocked: date in past', selected_event.date); toast.error(t("order_and_pickup.o_place_order.toast_select_date")); return; }

      const obj = {
        token: auth.data?.token,
        relnr: selected_customer,
        cn: selected_subpage,
        date: formatDateToYYYYMMDD(selected_event.date || new Date),
        reference: reference,
        coupures: coupures,
        kassa: quota_levels?.kassas.find(k => (k.cn || '').toLowerCase().includes(selected_subpage))?.kassaid?.toString() ?? null,
        orderperwafel: denom_settings.orderperwafel,
        ordercoins: denom_settings.ordercoins,
        ordernotes: denom_settings.ordernotes,
        announcecoins: denom_settings.announcecoins,
        announcenotes: denom_settings.announcenotes,
      }

      console.log('[PlaceOrder] saveOrder body', obj)


      toast.loading(t("order_and_pickup.o_place_order.toast_loading_order"), {id:'saveDraft'})
      console.log('[PlaceOrder] POST order/draft/create')
      const {data} = await axios.post(`order/draft/create`, obj)
      console.log('[PlaceOrder] order/draft/create response', data)
      if(data.errorcode !== 0) { throw new Error(data.errorcode) }

      if(!auth.data?.role){ console.error('[PlaceOrder] saveOrder ERROR: no role'); throw new Error('No role defined') }
      console.log(`[PlaceOrder] Concept created, role=${auth.data.role}, route=${auth.data.role < 5 ? '/validate' : '/tovalidate'}`)
      if(auth.data.role < 5){
        console.log('[PlaceOrder] POST order/draft/validate', { id: data.object.id })
        await axios.post(`order/draft/validate`, { token:auth.data?.token, id: data.object.id })

        ReactGA.event({
          category: 'Order validated',
          action: 'order_create_validate_success',
          value: auth.data.role
        })
      }
      else {
        console.log('[PlaceOrder] POST order/draft/tovalidate', { orders: data.object.id })
        await axios.post(`order/draft/tovalidate`, { token:auth.data?.token, orders: data.object.id })
        ReactGA.event({
          category: 'Order tovalidate',
          action: 'order_create_tovalidate_success',
          value: auth.data.role
        })
      }
      
      toast.success(t("order_and_pickup.o_place_order.toast_success_order"), {id:'saveDraft'})
      resetOrderSelection();
      refetch_concept();

      
      
    } catch (error) {
      console.error('[PlaceOrder] saveOrder ERROR', error);
      let errMessage = t("order_and_pickup.o_place_order.toast_error_order")
      if(typeof(error) === 'number'){
        if(error === 2301){ errMessage = t("errors.error-2301") }
        if(error === 2302){ errMessage = t("errors.error-2302") }
        if(error === 2303){ errMessage = t("errors.error-2303") }
        if(error === 2304){ errMessage = t("errors.error-2304") }
        if(error === 2305){ errMessage = t("errors.error-2305") }
        if(error === 2306){ errMessage = t("errors.error-2306") }
        if(error === 2307){ errMessage = t("errors.error-2307") }
        if(error === 2308){ errMessage = t("errors.error-2308") }
        if(error === 2309){ errMessage = t("errors.error-2309") }
        if(error === 2310){ errMessage = t("errors.error-2310") }
        if(error === 2311){ errMessage = t("errors.error-2311") }
        if(error === 2312){ errMessage = t("errors.error-2312") }
        if(error === 2313){ errMessage = t("errors.error-2313") }
        if(error === 2314){ errMessage = t("errors.error-2314") }
        if(error === 2315){ errMessage = t("errors.error-2315") }
        if(error === 2316){ errMessage = t("errors.error-2316") }
        if(error === 2317){ errMessage = t("errors.error-2317") }
      }

      toast.error(errMessage, {id:'saveDraft'})
      ReactGA.event({
        category: 'Order',
        action: 'order_failed',
      })

      try {
        await createTicket(auth, `
          PAGE: place order \n
          BODY:
          relnr: ${selected_customer},\n
          cn: ${selected_subpage},\n
          date: ${formatDateToYYYYMMDD(selected_event?.date || new Date)},\n
          reference: ${reference},\n
          coupures: ${JSON.stringify(coupures)}\n
          ERROR: ${error}
        `, error)
      } catch (error) {}
    }    
  }

  const onEdit = async (draft:OrderDraft) => {
    console.log('[PlaceOrder] onEdit draft', draft)
    isEdit.current = true;
    isEditDraft.current = draft.id
    window.scrollTo(0, 0);

    let relation = customers.find(obj => obj.eindklant.some(e => e.relnr === draft.relnr))
    let partner = partners.find(obj => obj.relnr === relation?.id)
    console.log('[PlaceOrder] onEdit resolved partner/relation', { relation, partner })
    if(partner) { await handlePickPartner(partner.relnr.toString()); } else { console.error('[PlaceOrder] onEdit ERROR: partner not found for draft.relnr', draft.relnr); toast.error('Error'); return; }

    setselected_customer(draft.relnr.toString())
    // kassa wordt afgeleid uit het type (draft.cn) via het kassa-effect, niet manueel gezet.

    let dt = convertToDate(draft.dtdelivery)
    if(dt) { 
      setselected_date(dt); 
      onPickDate({
        isSameMonth: isSameMonth(dt, new Date()),
        isToday: isToday(dt),
        isBeforeToday: isBefore(dt, new Date()),
        day: format(dt, "d"),
        date: dt,
        events: [],
        cn: draft.cn.toUpperCase() as 'C' | 'N',
        isSelected: true,
      }) 
    }
    
    setreference(draft.reference)

    let tmp_draft_coupures = [...draft.coupure] 
    tmp_draft_coupures.map(i=>i.qty=(i.qty/parseFloat(i.coupure)))
    tmp_draft_coupures.map(i=>i.coupure=i.coupure.toString() as CoupureType)
    setcoupures(tmp_draft_coupures)
  }

  const customerObject = Array.isArray(customers_list) ? customers_list.find(i=>i.relnr.toString()===selected_customer?.toString()) : undefined
  const isCustomerBulk = customerObject ? customerObject.bulk : false
  if(isCustomerBulk && isInterface(denom, {} as Denom)){
    if(denom.coins){
      denom.coins = denom.coins.map((c)=>{
        let u = {...c}
        if(u.perqty > 0){ u.perqty = 1}
        return u
      })
    }
    if(denom.notes){
      denom.notes = denom.notes.map((c)=>{
        let u = {...c}
        if(u.perqty > 0){ u.perqty = 1}
        return u
      })
    }
  }

  function isRequiredReference () {
    if(!selected_partner){ return false }
    const includes = CONFIG.order_and_collect.order.requiredReference_relnrs.includes(selected_partner)
    return includes
  }

  function isComplete() {
    if (no_quota_warning) return false
    const requiredRef = isRequiredReference()
    if(requiredRef){
      if(reference.length < 1){ return false }
    }
    if(getUnmetMinRows().length > 0){ return false }
    return true
  }

  const [edit_foreign_draft, setedit_foreign_draft] = useState<OrderDraft | undefined>(undefined);
  const handleClickEditForeign = (draft:OrderDraft) => {
    settype_order('foreign')
    setedit_foreign_draft(draft)
  }

  const handleSuccessForeign = () => {
    setedit_foreign_draft(undefined)
  }

  return (
    <>
    <Toaster />
    <div className='relative w-full p-4 overflow-auto md:p-8'>

        <Breadcrumb items={[{title:<p onClick={()=>{navigate('/bestellen-en-ophalen')}} className='cursor-pointer'>{t("order_and_pickup.o_place_order.link_orders")}</p>}, {title:t("order_and_pickup.o_place_order.link_place_order")}]}/>
        <h1 className='text-2xl font-semibold'>{t("order_and_pickup.o_place_order.title")}</h1>

        {CONFIG.order_and_collect.order.enable_foreign_currency &&
        <>
        {kassas?.some(i=>i.kassaactive) && 
        <div className='translate-y-4'>
          <Tab value={type_order} onValueChange={(value)=>{settype_order(value as 'eur' | 'foreign')}}>
            <TabItem value='eur'>EUR</TabItem>
            <TabItem value='foreign'>{t("order_and_pickup.o_place_order.foreign_currency")}</TabItem>
          </Tab>
        </div>
        }
        </>
        }

        {type_order === 'eur' && 
        <div className={`flex flex-col ${view_form && 'gap-4'} p-4 shadow-sm border rounded-sm mt-4 md:mt-8`}>

          <div className='flex justify-between'>
            <h2 className='text-lg'>{t("order_and_pickup.o_place_order.subtitle")}</h2>
            <button onClick={()=>{setview_form(prev=>!prev)}} className='flex items-start justify-end w-8 h-8 opacity-50 hover:opacity-100'>{view_form ? <Eye strokeWidth={1.5}/> : <EyeOff strokeWidth={1.5}/>}</button>
          </div>

          <div className={`${view_form ? '' : 'max-h-0'} duration-300 overflow-hidden flex flex-col gap-4`}>

            <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4'>
                <div>
                    <Label htmlFor='partner'>{t("order_and_pickup.o_place_order.partner")}</Label>
                    <Combobox disabled={partners?.length === 1} id='partner' selectedValue={selected_partner ? selected_partner : undefined} onValueChange={(value) => { handlePickPartner((value.value).toString()) }} options={Array.isArray(partners) ? partners.map((item) => ({value:item.relnr, label:item.name})) : []} placeholder={t("order_and_pickup.o_place_order.partner_placeholder")||""} input_placeholder={t("order_and_pickup.o_place_order.search_placeholder") || ""}/>
                </div>

                <div>
                    <Label htmlFor='end_customer'>{t("order_and_pickup.o_place_order.customer")}</Label>
                    <Combobox disabled={!Array.isArray(customers_list)} selectedValue={selected_customer ? selected_customer : undefined} id='end_customer' onValueChange={(value) => { console.log('[PlaceOrder] customer dropdown change', { from: selected_customer, to: value.value }); setselected_subpage(''); setcoupures(null); setselected_date(undefined); setselected_event(null); setselected_customer(value.value.toString()) }} options={Array.isArray(customers_list) ? customers_list.map((item)=> ({value:item.relnr, label:item.name})) : []} placeholder={t("order_and_pickup.o_place_order.customer_placeholder")||""} input_placeholder={t("order_and_pickup.o_place_order.search_placeholder") || ""}/>
                </div>

                <div>
                    <Label htmlFor='deliverydate'>{t("order_and_pickup.o_place_order.date_delivery")}</Label>
                    <PlannedStopsCalendar page='order' onSelectDay={(v)=>{onPickDate(v)}} disabled={selected_customer==='clear' || !(selected_partner !== null && selected_customer !== null && selected_customer)} partnerid={selected_partner ? parseFloat(selected_partner) : 0} clientrelnr={selected_customer ? parseFloat(selected_customer) : 0} setselectedDate={setselected_date} selectedDate={selected_date}/>
                </div>

                <div>
                    <Label htmlFor='reference' className='flex items-center gap-1 mb-1'>{t("order_and_pickup.o_place_order.reference")}{isRequiredReference() && <span className='text-primary'>*</span>}</Label>
                    <Input value={reference} onChange={({currentTarget})=>{setreference(currentTarget.value)}} id='reference'/>
                </div>
            </div>

            {/* Niveau-indicatie: van welk niveau komen de getoonde quota's. */}
            {selected_event && applied_level && (
              <div className='p-3 border border-blue-300 bg-blue-50 rounded-sm text-sm'>
                <p className='font-medium'>{t(`order_and_pickup.o_place_order.quota_source_${applied_level}`)}</p>
              </div>
            )}

            {/* Denominatie-UI pas tonen nadat een leveringsdatum gekozen is (het type hangt van de leverdag af). */}
            {selected_event && no_quota_warning && (
              <div className='p-3 border border-yellow-400 bg-yellow-50 rounded-sm text-sm'>
                <p className='font-medium'>{t("order_and_pickup.o_place_order.no_quota_warning")||"Geen quota's geconfigureerd voor deze selectie. Contacteer een beheerder."}</p>
              </div>
            )}

            {/* Guard rail: niveaus geladen maar geen enkel type orderbaar (eindklant/partner/kassa allemaal leeg). */}
            {selected_event && isInterface(denom, {} as Denom) && !quotaAvail.c && !quotaAvail.n && (
              <div className='p-3 border border-red-400 bg-red-50 rounded-sm text-sm'>
                <p className='font-medium'>{t("order_and_pickup.o_place_order.no_settings_warning")||"Geen denominatie-instellingen gevonden voor deze eindklant, partner of kassa. Contacteer een beheerder."}</p>
              </div>
            )}

            {/* Randgeval: leverdag heeft enkel een type zonder quota, terwijl het andere type elders wél quota heeft → nooit blanco. */}
            {selected_event && isInterface(denom, {} as Denom) && selected_subpage === '' && (quotaAvail.c || quotaAvail.n) && (
              <div className='p-3 border border-yellow-400 bg-yellow-50 rounded-sm text-sm'>
                <p className='font-medium'>{t("order_and_pickup.o_place_order.no_quota_for_day")||"Voor het type van deze leverdag is geen quota geconfigureerd. Kies een andere leverdag of contacteer een beheerder."}</p>
              </div>
            )}

            {/* Beide types die dag → gebruiker kiest; de bijhorende kassa wordt achterliggend bepaald. */}
            {selected_event?.cn === 'CN' && (quotaAvail.c || quotaAvail.n) &&
            <Tablist onValueChange={(value)=>{setselected_subpage(value as Subpage)}} value={selected_subpage}>
                {quotaAvail.c && <TablistItem value='c'>{t("order_and_pickup.o_place_order.coins")}</TablistItem>}
                {quotaAvail.n && <TablistItem value='n'>{t("order_and_pickup.o_place_order.notes")}</TablistItem>}
            </Tablist>
            }

            {/* Eén type die dag → toon het type als (vast) label zodat duidelijk is wat besteld wordt. */}
            {selected_event && selected_event?.cn !== 'CN' && selected_subpage !== '' &&
            <Tablist onValueChange={()=>{}} value={selected_subpage}>
                {selected_subpage === 'c'
                    ? <TablistItem value='c'>{t("order_and_pickup.o_place_order.coins")}</TablistItem>
                    : <TablistItem value='n'>{t("order_and_pickup.o_place_order.notes")}</TablistItem>}
            </Tablist>
            }

            {(() => {
              const denom_obj = isInterface(denom, {} as Denom) ? denom : null
              console.log('[PlaceOrder] render-gate', {
                selected_subpage,
                selected_event_cn: selected_event?.cn,
                denom_state: typeof denom === 'string' ? denom : 'object',
                denom_coins: denom_obj?.coins?.length ?? 'n/a',
                denom_notes: denom_obj?.notes?.length ?? 'n/a',
                ordercoins: denom_settings.ordercoins,
                ordernotes: denom_settings.ordernotes,
                no_quota_warning,
                will_render_coins: selected_subpage === 'c' && denom_settings.ordercoins && !!denom_obj,
                will_render_notes: selected_subpage === 'n' && denom_settings.ordernotes && !!denom_obj,
              })
              return null
            })()}
            {/* DEV ONLY — bypass planningskalender om Coins/Notes te kunnen testen zonder geldige leveringsdag */}
            {process.env.NODE_ENV === 'development' && isInterface(denom, {} as Denom) && selected_customer && selected_customer !== 'clear' && !selected_event && (
              <button
                type='button'
                onClick={() => {
                  const tomorrow = new Date()
                  tomorrow.setDate(tomorrow.getDate() + 1)
                  const fake_event: DayObject = {
                    isSameMonth: isSameMonth(tomorrow, new Date()),
                    isToday: isToday(tomorrow),
                    isBeforeToday: isBefore(tomorrow, new Date()),
                    day: format(tomorrow, 'd'),
                    date: tomorrow,
                    events: [],
                    cn: 'CN',
                    isSelected: true,
                  }
                  console.log('[PlaceOrder] DEV: synthetic date+event injected', fake_event)
                  setselected_date(tomorrow)
                  setselected_event(fake_event)
                  setselected_subpage(quotaAvail.c ? 'c' : (quotaAvail.n ? 'n' : ''))
                }}
                className='self-start text-xs px-2 py-1 rounded-sm bg-yellow-100 border border-yellow-400 text-yellow-900 hover:bg-yellow-200'
              >
                DEV: synthetische datum invullen (bypass planning)
              </button>
            )}
            {(denom === 'loading' && selected_subpage !== '') && <p>{t("order_and_pickup.o_place_order.loading")}</p>}
            {(denom === 'error' && selected_subpage !== '') && <p>{t("order_and_pickup.o_place_order.error")}</p>}
            {isInterface(denom, {} as Denom) &&
            <>
            {(isCustomerBulk && (selected_subpage === 'c' ||selected_subpage === 'n')) && <p className='flex items-center gap-2 py-1 pl-2 pr-3 text-sm font-medium rounded-full select-none bg-neutral-800/10 w-fit'><CoinsIcon className='w-4 h-4'/> {t("order_and_pickup.o_place_order.bulk_mode")}</p>}

            {selected_subpage === 'c' && quotaAvail.c && <Coins bulk={isCustomerBulk} onChangeInput={onChangeInput} denom={denom} coupures={coupures} currency='EUR'/>}
            {selected_subpage === 'n' && quotaAvail.n && <Notes bulk={isCustomerBulk} onChangeInput={onChangeInput} denom={denom} coupures={coupures} currency='EUR'/>}
            </>
            }

            {isCoupuresValid() && 
            <div>
              <Button disabled={!isComplete()} onClick={()=>{saveOrder()}} className='w-fit'>{t("order_and_pickup.o_place_order.button")}</Button>
              <Button disabled={!isComplete()} onClick={()=>{saveDraft()}} className='w-fit' variant='link'>{t("order_and_pickup.o_place_order.button_concept")}</Button>
            </div>
            }

          </div>
        </div>
        }

        {type_order === 'foreign' && <OrderForeignCurrencyForm defaultValue={edit_foreign_draft} onSuccess={()=>{handleSuccessForeign()}} defaultPartner={selected_partner} defaultCustomer={selected_customer}/>}

        <PreviousOrders selectedTab={type_order} />

        <Concept selectedTab={type_order} onEdit={(draft)=>{onEdit(draft)}} onEditForeign={(draft)=>{handleClickEditForeign(draft)}}/>
    </div>
    </>
  )
}

export default Main